<template>
	<div>
		<div class="margin-bottom padding-bottom border-bottom">
			<template v-if="loading">
				Loading ...
			</template>
			<template v-else>
				<div class="input-row">
					<div class="label">Charge/refund</div>
					<div>
						<div class="small-margin-bottom">
							<input type="number" v-model="amount" />
							<button :disabled="saving" v-on:click="charge()" class="small-margin-left">
								<template v-if="amount >= 0">Charge</template>
								<template v-else>Refund</template>
							</button>
						</div>
						<div class="small-margin-bottom" v-if="amount < 0">
							Reason:
							<br />
							<select v-model="return_reason">
								<option value="">[ None ]</option>
								<option value="duplicate">Duplicate charge</option>
								<option value="fraudulent">Fraudulent</option>
								<option value="requested_by_customer">Requested by customer</option>
							</select>
						</div>
						<div class="note">
							Type negative amount to refund
						</div>
					</div>
				</div>
				<div class="input-row small-margin-top" v-if="show_old_payment_notification">
					<div class="label">Email notification</div>
					<MaterialToggle v-model="old_payment_notification" label="Send email informing why we charge an old payment" />
				</div>
				<div class="input-row small-margin-top">
					<div class="label">Value</div>
					<div>
						{{ value }}
					</div>
				</div>
				<div class="input-row small-margin-top">
					<div class="label">Outstanding balace</div>
					<div>
						{{ outstanding_balance }}
					</div>
				</div>
				<div class="input-row small-margin-top">
					<div class="label">Amount ready for capture</div>
					<div>
						{{ amount_ready_for_capture }}
					</div>
				</div>
				<div class="input-row small-margin-top">
					<div class="label">Explanation</div>
					<div>
						<details v-if="detailed">
						    <summary>{{ explanation.message }}</summary>
						    {{ detailed }}
						</details>
						<div v-else-if="explanation">
							{{ explanation.message }}
						</div>
						<template v-else>N/A</template>
					</div>
				</div>
				<div class="input-row small-margin-top">
					<div class="label">Order status</div>
					<div>
						{{ order.status }}
					</div>
				</div>
				<div class="input-row small-margin-top">
					<div class="label">Comment</div>
					<div>
						<textarea v-model="comment" rows="3" cols="30" />
					</div>
				</div>
				<div class="input-row small-margin-top">
					<div class="label">Split payments</div>
					<div class="flex-grow" v-if="split_payments.length">
						<table style="width: 100%">
							<thead>
								<tr>
									<th>Payment date</th>
									<th>Amount</th>
									<th>Status</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="split_payment in split_payments">
									<td>{{ split_payment.payment_date }}</td>
									<td>{{ split_payment.amount }}</td>
									<td>
										<div v-if="!split_payment.capture_attempted_at && !split_payment.captured_at">Pending</div>
										<div class="red" v-if="split_payment.capture_attempted_at && !split_payment.captured_at">Capture failed</div>
										<div class="green" v-if="split_payment.captured_at">Captured</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-else>
						No split payments
					</div>
				</div>
			</template>
		</div>

		<TransactionHistory :id="id" />
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    comment: '',
    amount: 0,
    outstanding_balance: 0,
    value: 0,
    return_reason: '',
    loading: false,
    saving: false,
    order: {},
    split_payments: [],
    amount_ready_for_capture: 0,
    old_payment_notification: false,
    show_old_payment_notification: false,
    explanations: {
      1: 'When an exchange order is still open products can still be added to it. Therefore, it\'s not in a suitable state to start charging money on it. To proceed either close it manually or wait for it to close at 11:00 every day.'
    }
  }),
  computed: {
    detailed () {
      if (!this.explanation) {
        return false
      }

      if (this.explanation.message.match(/Code: [0-9]+/)) {
        var code = this.explanation.message.replace(/^.*?Code: ([0-9]+).*?$/, '$1')

        return this.explanations[Number(code)]
      }

      return false
    }
  },
  methods: {

    /**
			 * Load
			 *
			 * @return {void}
			 */
    load () {
      Vue.$api.get('/order/' + this.id + '/capture-status', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },

    /**
			 * [parse description]
			 * @param  {[type]} data [description]
			 * @return {[type]}      [description]
			 */
    parse (data) {
      console.log(data)

      this.order = data.order
      this.value = data.order_value.price
      this.outstanding_balance = data.outstanding_balance
      this.amount = data.amount_ready_for_capture
      this.split_payments = data.split_payments
      this.amount_ready_for_capture = data.amount_ready_for_capture
      this.show_old_payment_notification = data.show_old_payment_notification
      this.explanation = data.ready_for_capture_explanation
    },
    charge () {
      Vue.api.post('/order/' + this.id + '/charge', {
        amount: this.amount,
        reason: this.return_reason,
        old_payment_notification: this.old_payment_notification,
        comment: this.comment
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.success()
      })
    },
    success () {
      alert('Completed!')

      this.$emit('success')
    }
  },
  created () {
    this.load()
  }
}
</script>
